import type { ReactElement } from "react"
import { Switch, useRouteMatch } from "react-router-dom"
import type { RouteComponentProps } from "react-router-dom"

import {
  AssetManagerOverviewPage,
  AssetManagerPage,
  ChapterManagerOverviewPage,
  ChapterManagerPage,
  LicenceManagerOverviewPage,
  LicenceManagerPage,
  LinkChapterManagerOverviewPage,
  LinkChapterManagerPage,
  MapMetadataManagerOverviewPage,
  MapMetadataManagerPage,
  RegionManagerOverviewPage,
  RegionManagerPage,
  ThemeManagerOverviewPage,
  ThemeManagerPage
} from ".."

import type {
  IAssetManagerRouteParams,
  IChapterManagerRouteParams,
  ILicenceManagerRouteParams,
  ILinkChapterManagerRouteParams,
  IMapMetadataManagerRouteParams,
  IRegionManagerRouteParams,
  IThemeManagerRouteParams
} from ".."
import { GuardedRoute } from "../../atoms"
import { TopographyPage } from "../content-managers"

export function ContentManagerPageRouting(): ReactElement {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <GuardedRoute exact path={`${path}`}>
        <AssetManagerOverviewPage />
      </GuardedRoute>
      <GuardedRoute exact path={`${path}/assets`}>
        <AssetManagerOverviewPage />
      </GuardedRoute>
      <GuardedRoute exact path={`${path}/assets/create`}>
        <AssetManagerPage />
      </GuardedRoute>
      <GuardedRoute
        exact
        path={`${path}/assets/:assetId?`}
        render={(props: RouteComponentProps<IAssetManagerRouteParams>) => (
          <AssetManagerPage assetId={props.match.params.assetId} />
        )}
      />
      <GuardedRoute exact path={`${path}/metadata`}>
        <MapMetadataManagerOverviewPage />
      </GuardedRoute>
      <GuardedRoute exact path={`${path}/metadata/create`}>
        <MapMetadataManagerPage />
      </GuardedRoute>
      <GuardedRoute
        exact
        path={`${path}/metadata/:metadataId?`}
        render={(props: RouteComponentProps<IMapMetadataManagerRouteParams>) => (
          <MapMetadataManagerPage metadataId={props.match.params.metadataId} />
        )}
      />
      <GuardedRoute exact path={`${path}/licences`}>
        <LicenceManagerOverviewPage />
      </GuardedRoute>
      <GuardedRoute exact path={`${path}/licences/create`}>
        <LicenceManagerPage />
      </GuardedRoute>
      <GuardedRoute
        exact
        path={`${path}/licences/:id?`}
        render={(props: RouteComponentProps<ILicenceManagerRouteParams>) => (
          <LicenceManagerPage id={props.match.params.id} />
        )}
      />
      <GuardedRoute exact path={`${path}/regions`}>
        <RegionManagerOverviewPage />
      </GuardedRoute>
      <GuardedRoute exact path={`${path}/regions/create`}>
        <RegionManagerPage />
      </GuardedRoute>
      <GuardedRoute
        exact
        path={`${path}/regions/:regionId?`}
        render={(props: RouteComponentProps<IRegionManagerRouteParams>) => (
          <RegionManagerPage regionId={props.match.params.regionId} />
        )}
      />
      <GuardedRoute exact path={`${path}/chapters`}>
        <ChapterManagerOverviewPage />
      </GuardedRoute>
      <GuardedRoute exact path={`${path}/chapters/create`}>
        <ChapterManagerPage />
      </GuardedRoute>
      <GuardedRoute
        exact
        path={`${path}/chapters/:chapterId?`}
        render={(props: RouteComponentProps<IChapterManagerRouteParams>) => (
          <ChapterManagerPage chapterId={props.match.params.chapterId} />
        )}
      />
      <GuardedRoute exact path={`${path}/linkchapters`}>
        <LinkChapterManagerOverviewPage />
      </GuardedRoute>
      <GuardedRoute exact path={`${path}/linkchapters/create`}>
        <LinkChapterManagerPage />
      </GuardedRoute>
      <GuardedRoute
        exact
        path={`${path}/linkchapters/:chapterId?`}
        render={(props: RouteComponentProps<ILinkChapterManagerRouteParams>) => (
          <LinkChapterManagerPage chapterId={props.match.params.chapterId} />
        )}
      />
      <GuardedRoute exact path={`${path}/themes`}>
        <ThemeManagerOverviewPage />
      </GuardedRoute>
      <GuardedRoute exact path={`${path}/themes/create`}>
        <ThemeManagerPage />
      </GuardedRoute>
      <GuardedRoute
        exact
        path={`${path}/themes/:themeId?`}
        render={(props: RouteComponentProps<IThemeManagerRouteParams>) => (
          <ThemeManagerPage themeId={props.match.params.themeId} />
        )}
      />
      <GuardedRoute exact path={`${path}/topography`}>
        <TopographyPage />
      </GuardedRoute>
    </Switch>
  )
}
